import { muiTheme } from 'mui-theme'
import theme from 'theme'

export const DONUT_WIDTH = 200

const DONUT_COLORS = {
  /**
   * See https://mui.com/material-ui/customization/palette/#generate-tokens-using-augmentcolor-utility
   */
  blue: muiTheme.palette.augmentColor({
    color: {
      main: theme.colors.blue[0]
    },
    name: 'blue'
  }),
  purple: muiTheme.palette.augmentColor({
    color: {
      main: theme.colors.purple[0]
    },
    name: 'purple'
  })
}

export const RELIABILITY_REPORT_COLORS = {
  SCALABILITY: DONUT_COLORS.purple.light,
  REDUNDANCY: DONUT_COLORS.purple.main,
  DEPENDENCIES: DONUT_COLORS.purple.dark,
  RISKS: DONUT_COLORS.blue.light,
  OTHER: DONUT_COLORS.blue.main
}

export const reportTableStyles = {
  '& .MuiDataGrid-cell:focus': {
    outline: 0
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none'
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    width: '100%',
    justifyContent: 'center'
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    whiteSpace: 'initial',
    lineHeight: 'normal',
    textAlign: 'center'
  },
  border: 'none'
}
